<template>
  <div :class="['social-bar', 'ml-1']">
    <ul>
      <li v-for="(service, index) in services" :key="index">
        <a
          @click.prevent="popup(service.url(url, title()))"
          :href="service.url(url, title())"
          :title="firstLetterCapital(service.icon)"
          :class="['p-1', 'block']">
          <icon :name="service.icon" />
        </a>
      </li>
    </ul>
  </div>
</template>
<script>
import services from '../helpers/social-bar-services'
import methods from '../helpers/methods'

export default {
  name: 'SocialBar',
  mixins: [
    methods
  ],
  data () {
    return {
      services,
      url: window.location.href,
      popupWidth: 640,
      popupHeight: 480
    }
  }
}
</script>
<style>
.social-bar
{
  position: fixed;
  z-index: 1000;
  top: 50%;
  left: 0;
  transform: translate(0, -50%);
  filter: drop-shadow(0 0 var(--em-0) var(--darkest));
  border: solid 1px var(--darkest);
  border-left: 0;
  background: var(--darker);
  border-radius: 0 var(--border-radius) var(--border-radius) 0;
}

.social-bar a
{
  color: var(--white);
  opacity: .75;
  transition: var(--ease-in-out-back);
}

.social-bar:hover a
{
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/social-bar.vue